export default __webpack_public_path__ + "static/media/icon-facebook.d492b3a4.svg";